import { BaseContainerModel } from "../base-container.model";
import { bl_fi_generic_doc_line_open_queue_RowClass } from "../../dbschema";

export class GenericDocLineOpenQueueContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_line_open_queue: bl_fi_generic_doc_line_open_queue_RowClass =
    new bl_fi_generic_doc_line_open_queue_RowClass();
}
